import React, { useState, useEffect } from 'react';
import './ChangeReasonForm.css';

interface ChangeReasonFormProps {
  value: string;
  onChange: (reason: string) => void;
}

const ChangeReasonForm: React.FC<ChangeReasonFormProps> = ({ value, onChange }) => {
  const [selectedReason, setSelectedReason] = useState('');
  const [customReason, setCustomReason] = useState('');

  const predefinedReasons = [
    'Following a meeting or engagement',
    'Based on recent communication',
    'Stakeholder position or role changed',
    'Project milestone or deliverable',
    'Public statement or media coverage',
    'Relationship improvement observed',
    'Relationship deterioration observed',
    'Strategic priority shift',
    'Other (please specify)'
  ];

  // Initialize from value prop
  useEffect(() => {
    if (value) {
      if (predefinedReasons.includes(value)) {
        setSelectedReason(value);
        setCustomReason('');
      } else {
        setSelectedReason('Other (please specify)');
        setCustomReason(value);
      }
    }
  }, []);

  const handleReasonChange = (reason: string) => {
    setSelectedReason(reason);
    if (reason !== 'Other (please specify)') {
      onChange(reason);
      setCustomReason('');
    } else {
      onChange(customReason);
    }
  };

  const handleCustomReasonChange = (custom: string) => {
    setCustomReason(custom);
    onChange(custom);
  };

  return (
    <div className="change-reason-form">
      <label>Reason for Change *</label>
      <select 
        value={selectedReason} 
        onChange={(e) => handleReasonChange(e.target.value)}
        required
      >
        <option value="">Select a reason...</option>
        {predefinedReasons.map(reason => (
          <option key={reason} value={reason}>{reason}</option>
        ))}
      </select>

      {selectedReason === 'Other (please specify)' && (
        <textarea
          placeholder="Please describe the reason for this change (minimum 10 characters)..."
          value={customReason}
          onChange={(e) => handleCustomReasonChange(e.target.value)}
          minLength={10}
          required
          rows={3}
        />
      )}
    </div>
  );
};

export default ChangeReasonForm;
